define [], () ->
  name: 'forms', url: '^/forms/'
  template: require("./forms.jade")
  controller: require("./forms.coffee")
  children: [
    name: 'create_name', url: 'create_name/'
    controller: require('./create_name/create_name.coffee')
    template: require('./create_name/create_name.jade')
  ,
    name: 'select_reports', url: 'select_reports/'
    controller: require('./select_reports/select_reports.coffee')
    template: require('./select_reports/select_reports.jade')
    resolve:
      landlord: (Landlord) ->
        Landlord.getMe().$promise.then (response) ->
          return response
  ,
    name: 'quick_form', url: '^/quick_form/{applicationTemplateSlug}/'
    params: applicationTemplateSlug: {squash: true, value: null}
    controller: require("./quick_forms/quick_form.coffee")
    template: require("./quick_forms/quick_form.jade")
    resolve:
      defaultApplicationTemplate: (ApplicationTemplate) ->
        ApplicationTemplate.get id: "default"
        .$promise
      applicationTemplate: ($stateParams, ApplicationTemplate) ->
        if $stateParams.applicationTemplateSlug
          return ApplicationTemplate.getBySlug(slug: $stateParams.applicationTemplateSlug).$promise
        else
          return new ApplicationTemplate
  ]



// WEBPACK FOOTER //
// ./components/forms/routes.coffee